import type { QmsRegistryKind } from './qmsApi';

export function permissionKeyForKind(kind: QmsRegistryKind): string {
  return kind === 'claim' ? 'registros.claims.access' : 'registros.non_conformities.access';
}
